import styled from "@emotion/styled";
import { Col, Empty, FormInstance, Input, Radio, Row } from "antd";
import { FC, Dispatch, SetStateAction, useEffect, useState } from "react";
import { Pagination } from "antd";
import AgentAddressCard from "../AgentAddressCard";
import { AddressData } from "../interface/address.interface";
import { useAppSelector } from "store";
import { useGetTransportationTypeByFactory } from "hooks/useFactory";
interface AgentAddressCardListProp {
  form: FormInstance;
  dataAddress: AddressData[];
  setDataAddress?: Dispatch<SetStateAction<AddressData[]>>;
  handleRemoveItem?: (index: string) => void;
  showEdit?: (id: string) => void;
  changeDefault?: (id: string) => void;
  canUpdate?: boolean;
  radioSelect?: string;
  canSort?: boolean;
  hideActionMenu?: boolean;
}

const AgentAddressCardList: FC<AgentAddressCardListProp> = ({
  form,
  dataAddress,
  setDataAddress,
  handleRemoveItem,
  showEdit,
  changeDefault,
  canUpdate,
  radioSelect,
  canSort,
  hideActionMenu,
}) => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );
  const { data: transportationTypeData } = useGetTransportationTypeByFactory(
    factoryId ?? ""
  );

  const [defaultCheckedId, setDefaultCheckedId] = useState<string | null>(null);
  // let defaultCheckedId = null;
  // if (canUpdate) {
  //   defaultCheckedId =
  //     dataAddress.find((item) => item.is_default)?.address_id ||
  //     dataAddress.find((item) => item.is_default)?.temp_id ||
  //     '';
  // }

  const [address, setAddress] = useState<AddressData[]>([]);

  useEffect(() => {
    if (canUpdate) {
      setDefaultCheckedId(
        dataAddress.find((item) => item.is_default)?.address_id ||
          dataAddress.find((item) => item.is_default)?.temp_id ||
          ""
      );
    }
  }, [canUpdate]);

  useEffect(() => {
    let sortedData = dataAddress;
    if (canSort === true) {
      sortedData = [...dataAddress].sort((a, b) => {
        if (a.is_default && !b.is_default) {
          return -1;
        } else if (!a.is_default && b.is_default) {
          return 1;
        }
        if (a.province_name && b.province_name) {
          if (a.province_name < b.province_name) {
            return -1;
          } else if (a.province_name > b.province_name) {
            return 1;
          }
        }
        return 0;
      });
    }

    setAddress(sortedData);
  }, [dataAddress, transportationTypeData]);
  return (
    <>
      <WrapperAll>
        <HeadWrapper>
          {address && address.length > 0 && (
            <></>
            // <PaginationWrapper
            //   current={currentPage}
            //   size={'small'}
            //   responsive={true}
            //   // totalBoundaryShowSizeChanger={3}
            //   onChange={(page) => setCurrentPage(page)}
            //   // total={data?.contacts?.length || 0}
            //   total={1000}
            //   // defaultCurrent={3}
            //   // showTotal={showTotal}
            //   showSizeChanger
            //   // showQuickJumper
            //   pageSize={itemsPerPage}
            //   // showSizeChanger={false}
            // />
          )}
        </HeadWrapper>
        <StyledRadioGroup
          name="radiogroup"
          value={canUpdate ? defaultCheckedId : radioSelect}
        >
          <Row style={{ overflow: "auto", padding: "5px" }}>
            {address && address.length > 0 ? (
              address &&
              address.map((item, index) => {
                return (
                  <AgentAddressCard
                    key={index}
                    index={index}
                    data={item}
                    handleRemoveItem={handleRemoveItem}
                    showEdit={showEdit}
                    changeDefault={changeDefault}
                    canUpdate={canUpdate}
                    hideActionMenu={hideActionMenu}
                  />
                );
              })
            ) : (
              <Col span={24}>
                <NotFoundWrapper>
                  <Empty
                    description={"ไม่มีที่อยู่ กรุณาเพิ่มที่อยู่ใหม่"}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </NotFoundWrapper>
              </Col>
            )}
          </Row>
        </StyledRadioGroup>
      </WrapperAll>
    </>
  );
};

export default AgentAddressCardList;

const StyledRadioGroup = styled(Radio.Group)`
  border: none;
  margin: 0;
  display: block;
`;

const PaginationWrapper = styled(Pagination)`
  white-space: nowrap;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
`;

const NotFoundWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  flex-direction: column;
  width: 100%;
`;
